import { Button, Table, Text, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import { RouteList } from '@/shared/constants';
import { useProjectPath } from '@/shared/projects/project-path';

import {
  useGetAuthor,
  useGetAuthorBooks,
} from '../model/author-detail-page.cases';
import styles from './author-detail-page.module.scss';

export const AuthorDetailPage = () => {
  const navigate = useNavigate();
  const withProject = useProjectPath();
  const getAuthorQuery = useGetAuthor();
  const getAuthorBooksQuery = useGetAuthorBooks();

  function goToEditAuhtor() {
    const authorId = getAuthorQuery.data?.id;

    if (authorId) {
      navigate(withProject(RouteList.EDIT_AUTHOR(String(authorId))));
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <Title order={1} size={44} className={styles.title}>
            {getAuthorQuery.data?.name}
          </Title>
          {getAuthorQuery.data?.description && (
            <Text className={styles.description}>
              {getAuthorQuery.data.description}
            </Text>
          )}
          {getAuthorQuery.data?.birthday && (
            <Text>Дата рождения: {getAuthorQuery.data.birthday}</Text>
          )}
          <Button
            variant="outline"
            className={styles.editButton}
            onClick={goToEditAuhtor}
          >
            Редактировать автора
          </Button>
        </div>
      </div>

      <div className={styles.books}>
        <p className={styles.booksTitle}>Список книг</p>
        <Table withTableBorder flex={1}>
          <Table.Thead>
            <Table.Tr>
              <Table.Th className={styles.tableHeadCell}>Обложка</Table.Th>
              <Table.Th className={styles.tableHeadCell}>Название</Table.Th>
              <Table.Th className={styles.tableHeadCell}>Автор</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {getAuthorBooksQuery.data?.books?.map((book) => (
              <Table.Tr
                key={book.id}
                className={styles.tableRow}
                onClick={() =>
                  navigate(
                    withProject(RouteList.BOOK_DETAILS(book.id.toString())),
                  )
                }
              >
                <Table.Td width="20%">
                  <img
                    src={book.imgUrl}
                    alt="preview"
                    className={styles.tableBookPreview}
                  />
                </Table.Td>
                <Table.Td className={styles.tableBookName} width="50%">
                  {book.title}
                </Table.Td>
                <Table.Td className={styles.tableBookAuthorName} width="30%">
                  {book.author}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
        {/* <Button variant="outline" onClick={() => navigate(RouteList.BOOKS)}>
          Открыть полный список
        </Button> */}
      </div>
    </div>
  );
};
